import React from "react";
import metadata from "../../../metadata.json";

const SEO = ({
  title,
  description,
  author,
  ogurl,
  ogtype,
  ogtitle,
  ogdescription,
  ogimage,
  ogsitename,
  fbappid,
  shouldhideMetaTags,
  twittercard,
  twittertitle,
  twittersite,
  twitterimage,
  twitterdescription,
  canonical,
  publisher,
  detail,
  pathname,
  keywords,
}) => {
  const {
    twittercreator: metadataTwitterCreator,
    georegion: metadataGeoregion,
    geoplacename: metadataGeoplacename,
    geoposition: metadataGeoposition,
    ICBM: metadataICBM,
    alternate: metadataAlternate,
    hreflang: metadataHreflang,
    ...restMetadata
  } = metadata;

  const joinUrl = (baseUrl, path = "") => {
    if (!path) return baseUrl;

    const normalizedBaseUrl = baseUrl.replace(/\/+$/, "");
    const normalizedPath = path.replace(/^\/+/, "");

    return `${normalizedBaseUrl}/${normalizedPath}`;
  };

  const seo = {
    title: title || restMetadata.title,
    description: description || restMetadata.description,
    author: author || restMetadata.author,
    ogurl: ogurl || joinUrl(restMetadata.ogurl, pathname),
    ogimage: ogimage || restMetadata.ogimage,
    ogsitename: ogsitename || restMetadata.ogsitename,
    ogtitle: ogtitle || title || restMetadata.ogtitle,
    ogtype: ogtype || restMetadata.ogtype,
    fbappid: fbappid || restMetadata.fbappid,
    ogdescription: ogdescription || description || restMetadata.ogdescription,
    twittercard: twittercard || restMetadata.twittercard,
    twitterdescription:
      twitterdescription || description || restMetadata.twitterdescription,
    twittertitle: twittertitle || title || restMetadata.twittertitle,
    twittersite: twittersite || restMetadata.twittersite,
    twitterimage: twitterimage || ogimage || restMetadata.twitterimage,
    twittercreator: metadataTwitterCreator,
    georegion: metadataGeoregion,
    geoplacename: metadataGeoplacename,
    geoposition: metadataGeoposition,
    ICBM: metadataICBM,
    canonical: canonical || joinUrl(restMetadata.canonical, pathname),
    publisher: publisher || restMetadata.publisher,
    alternate: joinUrl(metadataAlternate, pathname),
    hreflang: metadataHreflang,
    detail: detail || restMetadata.detail,
    keywords: keywords || restMetadata.keywords,
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="author" content={seo.author} />
      <meta property="og:url" content={seo.ogurl} />
      <meta property="og:type" content={seo.ogtype} />
      <meta property="og:title" content={seo.ogtitle} />
      <meta property="og:description" content={seo.ogdescription} />
      <meta property="og:image" content={seo.ogimage} />
      {!shouldhideMetaTags && (
        <>
          <meta property="og:site_name" content={seo.ogsitename} />
          <meta property="fb:app_id" content={seo.fbappid} />
        </>
      )}
      <meta name="twitter:card" content={seo.twittercard} />
      <meta name="twitter:description" content={seo.twitterdescription} />
      <meta name="twitter:title" content={seo.twittertitle} />
      <meta name="twitter:site" content={seo.twittersite} />
      <meta name="twitter:image" content={seo.twitterimage} />
      <meta name="twitter:creator" content={seo.twittercreator} />
      {!shouldhideMetaTags && (
        <>
          <meta name="geo.region" content={seo.georegion} />
          <meta name="geo.placename" content={seo.geoplacename} />
          <meta name="geo.position" content={seo.geoposition} />
          <meta name="ICBM" content={seo.ICBM} />
        </>
      )}
      <link rel="canonical" href={seo.canonical} />
      <link rel="publisher" href={seo.publisher} />
      {!shouldhideMetaTags && (
        <>
          <link rel="alternate" href={seo.alternate} hrefLang={seo.hreflang} />
        </>
      )}
      <meta name="detail" content={seo.detail} />
      <meta name="keywords" content={seo.keywords} />
    </>
  );
};

export default SEO;
